import { MessageBox } from '@schuettflix/react-components';
import { useTranslation } from 'react-i18next';
import { SUPPORTED_UNIT_LABEL } from '@/phrase/SupportedUnitLabels.ts';
import { VehicleClass } from '@/shared/models/ContextDataModel/interfaces/entities/vehicle-class.ts';

type QuantityInTonsMessageBoxProps = {
    numberOfTransports: number;
    vehicleClass: VehicleClass;
};

export function QuantityInTonsMessageBox({ numberOfTransports, vehicleClass }: QuantityInTonsMessageBoxProps) {
    const { t } = useTranslation();

    const localizationKeyParams = {
        vehicleName: vehicleClass.name,
        transportQuantity: numberOfTransports,
        amount: `${vehicleClass.payloadInTons * numberOfTransports} ${t(SUPPORTED_UNIT_LABEL.TON)}`,
    };

    return (
        <MessageBox type="info" className="col-span-full">
            {numberOfTransports > 1
                ? t('forms.inputs.transportQuantityAndVehicleClassInput.messageBox.info.other', localizationKeyParams)
                : t('forms.inputs.transportQuantityAndVehicleClassInput.messageBox.info.one', localizationKeyParams)}
        </MessageBox>
    );
}
